import { Users } from '@/users/users.model';
import { Vehicle, VehicleKind } from '@/vehicles/vehicle.model';

export interface BankCardsHistory {
	id: string;
	numberId: string;
	operation: string;
	originalDocument: boolean;
	currentOwnerTransactions: string;
	fv_number: string;
	verified: boolean;
	comment: string;
	countValue: string;
	country: string;
	cardId: string;
	cardNumber: string;
	class: string;
	quantity: string;
	type: string;
	currency: string;
	fvNumber: string;
	edited: boolean;
	positionId: string;
	tourismEventId: string;
	tourismEventNewId: string;
	tourismEventIdName: string;
	tourismEventName: string;
	linkEvents: string;
}

export interface BankCardsHistoryPosition {
	id: string;
	name: string;
	value: string;
	quantity: string;
	currency: string;
	comment: string;
	linkEvents: string;
	currentOwnerName: string;
	dateoperation: string;
	bankCardsHistory: string;
	verified: number;
	type: string;
}

export interface TransactionKind {
	countriesId: string;
	exportNawigator: string;
	id: string;
	name: string;
	status: string;
}

export interface BankOwnersTypesOther {
	id: string;
	name: string;
}

export interface BankOwnersTypes {
	id: string;
	name: string;
}

export interface BankDepartments {
	id: string;
	name: string;
	status: BankArchiveStatus;
}

export interface CurrentOwnerName {
	currentOwnerName: string;
}

export interface BankCardsHistoryParameters {
	currentOwnerName: CurrentOwnerName[];
}

export interface BankSummaryValue {
	all: number;
	out: number;
}

export interface BankFilters {
	dateFrom: string;
	dateTo: string;
	currentOwnerName: string;
	currentOwnerTransactions: string;
	type: string;
	objType: string;
	originalDocument: string;
	verified: string;
	calculated: string;
	search: string;
	ownerType: string;
	ownerId: string;
}

export interface BankHistoryOperations {
	bankCardsHistoryPosition: string;
	type: string;
	value: string;
	user: string;
	date: string;
	name: string;
	userName: string;
}

export interface BankCards {
	id: string;
	commnets: string;
	currentOwnerId: string;
	currentOwnerName: string;
	currentOwnerType: string;
	number: string;
	status: string;
}

export interface BankCardsParameters {
	yesno: YesNo[];
	users: Users[];
	vehicles: Vehicle[];
}

export enum BankArchiveStatus {
	ACTIVE = '1',
	INACTIVE = '2',
}

export enum ActionKind {
	VERIFIED = 'verified',
	CALCULATED = 'calculated',
	ORIGINAL_DOCUMENT = 'originalDocument',
}

export enum OwnerKind {
	EMPLOYEE = '1',
	DRIVER = '2',
	COACH = '3',
	DEMPARTMENT = '4',
	TIR = '5',
	OTHER = '6',
}

export const BankVehicleKind = [VehicleKind.BUS, VehicleKind.FLIX_COACH, VehicleKind.COACH, VehicleKind.CAR];

export interface YesNo {
	id: number;
	name: string;
}

export interface BankCardsFilters {
	status: string;
	currentOwnerId: string;
}

export interface BankCard {
	id: number;
	number: string;
	comments: string;
	status: BankArchiveStatus;
}

export interface BankCardOwner {
	id: number;
	bankCard: number;
	ownerType: string;
	ownerId: number;
	dateFrom: string;
	dateTo: string;
}

export interface BankCardPosition {
	id: string;
	bankCardsHistory: string;
	value: string;
	verified: number;
	type: string;
	comment: string;
	linkEvents: string;
	tourismEventName: string;
	tourismEventIdName: string;
}

export interface BankCardOwnerPosition {
	id: number;
}

export interface BankVehicles {
	id: string;
	type: BankVehicleType;
	name: string;
}

export interface BankVehicleType {
	id: VehicleKind;
	name: string;
}

export interface Country {
	id: string;
	name: string;
}

export interface BankTransactionsBulkUpdateDialogData {
	selected: BankCardsHistory[];
	countries: Country[];
	types: TransactionKind[];
	currentOwnerTransactions: CurrentOwnerName[];
}
